import React from 'react';
import TimerSplashIntakePage from '../../../molecules/timerSplashIntake/TimerSplashPage';
import appStrings from '../../../../../common/app_strings';

const {
  wholemeIntake: {
    splashText: {
      woohoo: {
        title, subtitle,
      },
    },
  },
} = appStrings;

const WoohooBasicSplash = ({
  nextOnClick,
  paginationMeta,
}) => (
  <TimerSplashIntakePage
    nextOnClick={nextOnClick}
    paginationMeta={paginationMeta}
    pushTimer={8000}
    title={title}
    subtitle={subtitle}
    editText
  />
);

export default WoohooBasicSplash;
